import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MockUpUtil } from '@xengage/gw-portals-util-js';
import { ClauseService } from 'gw-capability-policycommon';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import presentationMetadata from '../config/PremierPR-wizard-config.json5';

const PATH_TO_MOCK_DATA = 'quote.PremierPR';
const MOCK_DATA_TO_REMOVE = ['bindData.contactPhone'];

export default ({
    productCode,
    history,
    location,
    viewModelService,
    setIsLoading,
}) => {
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [submissionVM, setInitialSubmission] = useState(null);
    const [wizardSteps, setWizardSteps] = useState(null);
    const [wizardTitle, setWizardTitle] = useState(null);

    useEffect(() => {
        const loadSubmission = async () => {
            if (!location.state) {
                history.push('/');

                return;
            }

            const { postalCode, quoteID } = location.state.quoteentry;
            const requestData = {
                quoteID,
                postalCode,
            };

            LoadSaveService.retrieveSubmission(requestData, authHeader)
                .then(response => MockUpUtil.cleanUpMockedProperties(
                    response,
                    PATH_TO_MOCK_DATA,
                    ...MOCK_DATA_TO_REMOVE
                ))
                .then(response => {
                    ClausesUtil.getDependentClausesFromServer(
                        ClauseService,
                        _.get(response, 'quoteID'),
                        authHeader
                    );

                    const initialSubmission = viewModelService.create(
                        response,
                        'pc',
                        'edge.capabilities.quote.submission.dto.QuoteDataDTO'
                    );

                    setInitialSubmission(initialSubmission);

                    const steps = _.get(presentationMetadata, [`${productCode}.default.wizard`, 'steps'])
                    const selectOffering = response.lobData.perLine.selectedOffering_Ext
                    const s = _.filter(steps, (step) => !step.id.includes('off') || step.id.includes(selectOffering))

                    setWizardSteps(s);
                    setIsLoading(false);
                });

            setWizardTitle(
                _.get(presentationMetadata, [
                    `${productCode}.default.wizard`,
                    'title',
                ])
            );

        };

        loadSubmission();
    }, [LoadSaveService, authHeader, history, location.state, productCode, setIsLoading, viewModelService]);

    return {
        submissionVM,
        wizardSteps,
        wizardTitle,
        presentationMetadata,
    };
};